<svg
  width="82"
  height="55"
  viewBox="0 0 82 55"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.7907 50.5158L5.23773 47.3693L6.68475 51.0126H8.02842L9.52713 48.9425L10.8708 42.4012L12.2661 51.5922L13.9199 50.1018L15.1085 48.6113L16.5039 51.4266L17.8475 52.8343L19.2429 1L20.6899 46.8725L22.0853 45.2164L23.4806 39.5859L24.9276 46.6241L26.2196 47.6177L27.7183 46.6241L29.1654 52.8343L30.4574 50.433L31.8527 48.8597L33.3514 41.9872L34.7468 44.8024L36.0904 52.089L37.5891 49.1082L38.8811 49.9362L40.3282 47.6177L41.7752 43.5604L43.2222 50.433L44.6176 42.3184L45.9612 40.2483L47.4083 49.6878L48.7519 47.2037L50.199 46.2101L51.5943 50.9298L53.0413 49.5222L54.385 50.9298L55.832 47.3693L57.2274 46.3757L58.6744 52.0062L60.0698 37.2674L61.4615 52.9594L61.4947 52.9595L62.8605 51.0954L64.3075 50.847L65.7028 52.4202L67.0982 42.5668L68.4418 47.7833L69.8889 37.847L71.2842 52.0062L72.6796 45.6305H74.0749L75.5219 50.2674L76.9173 51.5922L79.708 48.5285L81 38.3612L81 52.9999L61.4947 52.9595L61.4651 52.9999L61.4615 52.9594L1 52.8343V48.7394L3.7907 50.5158Z"
    fill="url(#paint0_linear_394_94)"
  />
  <path
    d="M1 48.9425L3.7907 50.5158L5.23773 47.3693L6.68475 51.0126H8.02842L9.52713 48.9425L10.8708 42.4012L12.2661 51.5922L13.9199 50.1018L15.1085 48.6113L16.5039 51.4266L17.8475 52.8343L19.2429 1L20.6899 46.8725L22.0853 45.2164L23.4806 39.5859L24.9276 46.6241L26.2196 47.6177L27.7183 46.6241L29.1654 52.8343L30.4574 50.433L31.8527 48.8597L33.3514 41.9872L34.7468 44.8024L36.0904 52.089L37.5891 49.1082L38.8811 49.9362L40.3282 47.6177L41.7752 43.5604L43.2222 50.433L44.6176 42.3184L45.9612 40.2483L47.4083 49.6878L48.7519 47.2037L50.199 46.2101L51.5943 50.9298L53.0413 49.5222L54.385 50.9298L55.832 47.3693L57.2274 46.3757L58.6744 52.0062L60.0698 37.2674L61.4651 52.9999L62.8605 51.0954L64.3075 50.847L65.7028 52.4202L67.0982 42.5668L68.4418 47.7833L69.8889 37.847L71.2842 52.0062L72.6796 45.6305H74.0749L75.5219 50.2674L76.9173 51.5922L79.708 48.5285L81 38.1782"
    stroke="currentColor"
  />
  <defs>
    <linearGradient
      id="paint0_linear_394_94"
      x1="41"
      y1="1"
      x2="41"
      y2="52.9999"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="currentColor" />
      <stop offset="1" stop-color="currentColor" stop-opacity="0" />
    </linearGradient>
  </defs>
</svg>
